import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";

export const ConfiguracionEmpresaService = {
    CrearConfiguracion,
    ActualizarConfiguracion,
    ListarConfiguracionEmpresa,
    FiltrarConfiguracionEmpresa,
    EliminarConfiguracionEmpresa
}

function CrearConfiguracion(data) {
    return fetch(
        `${Url}configuracion_empresa/crear_configuracion`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function ActualizarConfiguracion(data) {
  const id = data?.id;

  if (!id) {
    throw new Error("Se requiere el id de la configuración para actualizar");
  }

  const payload = { ...data };  
  delete payload.id;

    return fetch(
    `${Url}configuracion_empresa/actualizar_configuracion/${id}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
      body: JSON.stringify(payload)
        }
    ).then(HandleResponse);
}

function ListarConfiguracionEmpresa(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.per_page) queryParams.append("per_page", params.per_page);
  if (params.estado) queryParams.append("estado", params.estado);
  if (params.id_empresa) queryParams.append("id_empresa", params.id_empresa);

  const queryString = queryParams.toString();
  const url = `${Url}configuracion_empresa/listar_configuraciones${queryString ? "?" + queryString : ""}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function EliminarConfiguracionEmpresa(id) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };

  return fetch(`${Url}configuracion_empresa/eliminar_configuracion/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function FiltrarConfiguracionEmpresa(id) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}configuracion_empresa/obtener_configuracion/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}